/**
 * @generated SignedSource<<132f7fa84794073a27d3dafb7251db8b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BookmarkTabModalAddMutation$variables = {
  isEmbedded?: boolean | null;
  link: string;
  streamId: string;
  title: string;
};
export type BookmarkTabModalAddMutation$data = {
  readonly StreamTab_AddBookmarkTab: {
    readonly stream: {
      readonly id: string;
      readonly tabs: ReadonlyArray<{
        readonly icon: string | null;
        readonly id: string;
        readonly isEmbedded: boolean;
        readonly order: number;
        readonly otherStreamId: string | null;
        readonly title: string;
        readonly url: string | null;
      }>;
    };
  } | null;
};
export type BookmarkTabModalAddMutation = {
  response: BookmarkTabModalAddMutation$data;
  variables: BookmarkTabModalAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEmbedded"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "link"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "streamId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "isEmbedded",
        "variableName": "isEmbedded"
      },
      {
        "kind": "Variable",
        "name": "link",
        "variableName": "link"
      },
      {
        "kind": "Variable",
        "name": "streamId",
        "variableName": "streamId"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "title"
      }
    ],
    "concreteType": "AddBookmark",
    "kind": "LinkedField",
    "name": "StreamTab_AddBookmarkTab",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "stream",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStreamTabNode",
            "kind": "LinkedField",
            "name": "tabs",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "otherStreamId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "order",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isEmbedded",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BookmarkTabModalAddMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "BookmarkTabModalAddMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "31770631254af9a0ea85914c70c6eb8d",
    "id": null,
    "metadata": {},
    "name": "BookmarkTabModalAddMutation",
    "operationKind": "mutation",
    "text": "mutation BookmarkTabModalAddMutation(\n  $streamId: ID!\n  $title: String!\n  $link: String!\n  $isEmbedded: Boolean\n) {\n  StreamTab_AddBookmarkTab(streamId: $streamId, title: $title, link: $link, isEmbedded: $isEmbedded) {\n    stream {\n      id\n      tabs {\n        id\n        otherStreamId\n        icon\n        title\n        order\n        isEmbedded\n        url\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9e667e5c605c8f8a81ce08b1f9542290";

export default node;
